// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1Z_pp","rootSmall":"AddTileButton_rootSmall__2JSBN"};